import { render, staticRenderFns } from "./AddAutoDispatchingOrder.vue?vue&type=template&id=59686c80&scoped=true"
import script from "./AddAutoDispatchingOrder.vue?vue&type=script&lang=js"
export * from "./AddAutoDispatchingOrder.vue?vue&type=script&lang=js"
import style0 from "./AddAutoDispatchingOrder.vue?vue&type=style&index=0&id=59686c80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59686c80",
  null
  
)

export default component.exports